import { render } from "./EditTypeChambre.vue?vue&type=template&id=6420d288&scoped=true"
import script from "./EditTypeChambre.vue?vue&type=script&lang=js"
export * from "./EditTypeChambre.vue?vue&type=script&lang=js"

import "./EditTypeChambre.vue?vue&type=style&index=0&id=6420d288&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6420d288"]])

export default __exports__